<template>
    <section class="Section">
        <div class="Container WhiteBox">
            <div class="BoxWide">
                <div class="Bookmark Linked"><span></span> 
                    <div class="Button CustomColor ExtraSmall">                        
                        <router-link :to="{name: 'StoricoInterventi'}">Storico Interventi</router-link>
                    </div>
                </div>
            </div>
            <FiltroInterventi :showStatoFilter="true" @FiltraInterventi="this.filtraInterventi($event)" @RimuoviFiltri="this.rimuoviFiltri"></FiltroInterventi>
        </div>
        <div class="Container Counter">
            <GrigliaInterventiInCorso :listaInterventi="this.listaInterventi"></GrigliaInterventiInCorso>
        </div>
    </section>        
</template>

<script>

import FiltroInterventi from "@/components/FiltroInterventi.vue";
import GrigliaInterventiInCorso from "@/components/GrigliaInterventiInCorso.vue";
import {apiMixin, interventiMixin} from "/mixin.js";
import Intervento from "@/models/intervento.model.js";

export default {
    name: "Interventi",
    mixins: [apiMixin, interventiMixin],    
    components:{
        FiltroInterventi,
        GrigliaInterventiInCorso       
    },
    mounted: function(){

        this.doApiCall("get", "interventi/GetInterventiInCarico", this.$store.getters.getUtente.Token).then(

            (data) => {                
                if(data){
                    this.listaInterventi = data.map(o => {
                        return Object.assign(new Intervento(), o)
                    });
                this.listaInterventiOriginale = this.listaInterventi;
                }
            }
        );
    }

}
</script>